import { Fragment, useState, useEffect, useRef } from "react";
import { Popover, Transition } from "@headlessui/react";
import vricon from "../images/WhiteNavbaricons/vr.png";
import vtoicon from "../images/WhiteNavbaricons/vto.png";
import avataricon from "../images/WhiteNavbaricons/3d avatar.png";
import scanicon from "../images/WhiteNavbaricons/3d scan.png";
import vr from "../images/DarkNavbaricons/vr.png";
import vto from "../images/DarkNavbaricons/vto.png";
import avatar from "../images/DarkNavbaricons/3d avatar.png";
import scan from "../images/DarkNavbaricons/3d scan.png";
import { getBrowserEnv } from "../utils/browserEnv";
import PrimaryButton from "./PrimaryButton";
import { motion } from "framer-motion";
import RetainerSectionModal from "./RetainerSectionModal";

import Bars3Icon from "../heroicons/Bars3Icon";
import XMarkIcon from "../heroicons/XMarkIcon";
import ChevronDownIcon from "../heroicons/ChevronDownIcon";

const env = getBrowserEnv();

const solutions = [
  {
    name: "AR 3D Modeling Services",
    description: "Get your low-poly 3D assets created for XR space",
    href: "/augmented-reality-3d-modeling-services",
    lmicon: vricon,
    dmicon: vr,
  },
  {
    name: "VR 3D Modeling Services",
    description: "Get your low-poly 3D assets created for XR space",
    href: "/virtual-reality-3d-modeling-services",
    lmicon: vricon,
    dmicon: vr,
  },
  {
    name: "3D Scan Cleanups",
    description: "Create beautiful, clean and professional looking 3D models",
    href: "/3d-scan-cleanup-services",
    lmicon: scanicon,
    dmicon: scan,
  },
  {
    name: "Metaverse 3D Avatar Creator",
    description:
      "Foray into metaverse with your 3D models and establish your 3D footprint",
    href: "/metaverse-3d-avatars",
    lmicon: avataricon,
    dmicon: avatar,
  },
  {
    name: "Virtual Try On Solutions",
    description: "Get your Virtual Try On Solutions",
    href: "/virtual-try-on-solutions",
    lmicon: vtoicon,
    dmicon: vto,
  },
  {
    name: "3D Virtual Spaces",
    description: "3D Virtual Spaces for Immersive Visualization",
    href: "/3d-virtual-spaces",
    lmicon: vricon,
    dmicon: vr,
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Header() {
  const heightRef = useRef(null);
  const [currentPage, setCurrentPage] = useState("media");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("theme") == null) {
      document.body.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.body.classList.add(localStorage.getItem("theme"));
    }

    if (window.location.pathname === "/media/3d-blog/") {
      setCurrentPage("blog");
    } else {
      setCurrentPage("media");
    }
  }, []);

  return (
    <motion.div
      initial={{ y: -70 }}
      animate={{ y: 0 }}
      transition={{ duration: 1 }}
      className="flex flex-col z-[99999] bg-transparent sticky top-0 shadow-sm w-full"
    >
      {showModal && <RetainerSectionModal setShowModal={setShowModal} />}
      <div
        onClick={() => setShowModal(true)}
        className={`cursor-pointer text-center w-full text-[14px] p-[5px] text-white bg-gradient-to-r from-[#015EF1] to-[#489BE1] z-20`}
      >
        Elevate your vision with our 3D artists, sculpting ideas into masterful
        designs.{" "}
        <span
          onClick={() => setShowModal(true)}
          className="underline cursor-pointer"
        >
          Hire us now
        </span>
      </div>
      <Popover>
        <div
          ref={heightRef}
          className="mx-auto w-full relative"
        >
          <div className="top-0 bottom-0 left-0 right-0 absolute z-10 backdrop-blur-sm backdrop bg-[#0A0C10]"></div>
          <div
            id="head"
            className="flex items-center justify-between py-4 tab:py-6 mx-6 tab:mx-12 lg:mx-[112px] xl:mx-[138px] z-20 relative  max-w-[1920px] xxl:mx-auto"
          >
            <a
              href="/"
              className="justify-start"
            >
              <img
                src={`${env.CDN_BASE_URL}/miscellaneous/Header_Logo_D.png`}
                alt="Ikarus3D Logo"
                className="h-[28px] tab:h-[32px] md:h-[36px]"
              />
            </a>

            <div className="-my-2 -mr-2 md:hidden">
              <Popover.Button className="inline-flex items-center justify-center rounded-[5px] bg-primaryDarkBg p-2 text-primaryWhite focus:outline-none focus:ring-2 focus:ring-inset focus:ring-ikarus-blue">
                <span className="sr-only">Open menu</span>
                <Bars3Icon
                  className="h-6 w-6"
                  aria-hidden="true"
                />
              </Popover.Button>
            </div>
            <div className="hidden md:flex justify-end gap-8 items-center">
              <Popover.Group
                as="nav"
                className="relative space-x-6 lap:space-x-8 xl:space-x-10 flex"
              >
                <a
                  href="/about-us"
                  className={`text-[14px] xl:text-[16px] leading-4 xl:leading-6 tracking-[0.07px] font-[500] flex items-center ${
                    currentPage === "about-us"
                      ? "dark:text-ikarus-blue"
                      : "text-primaryWhite"
                  } relative overflow-y-hidden`}
                >
                  <span className="">About us</span>
                  <div
                    className={`w-full h-[2px] absolute ${
                      currentPage === "about-us" ? "bottom-0" : "-bottom-1"
                    } transition-all duration-300 ease-linear rounded-t-[3px] bg-primaryBlue`}
                  ></div>
                </a>
                <Popover className="">
                  {({ open }) => (
                    <>
                      <Popover.Button
                        className={classNames(
                          open ? "text-primaryWhite" : "text-primaryWhite",
                          "relative group inline-flex overflow-y-hidden items-center text-[14px] xl:text-[16px] leading-4 xl:leading-6 tracking-[0.07px] font-[500] text-primaryWhite focus:outline-none"
                        )}
                      >
                        <span className="">Services</span>
                        <span
                          className={`w-full h-[2.5px] absolute ${
                            currentPage === "services"
                              ? "bottom-0"
                              : "-bottom-1"
                          } transition-all duration-300 ease-linear rounded-t-[3px] bg-primaryBlue`}
                        ></span>
                        <ChevronDownIcon
                          className={classNames(
                            open ? "text-primaryWhite" : "text-primaryWhite",
                            "mt-[1px] h-5 w-5"
                          )}
                          aria-hidden="true"
                        />
                      </Popover.Button>

                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="opacity-0 translate-y-1"
                        enterTo="opacity-100 translate-y-0"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 translate-y-0"
                        leaveTo="opacity-0 translate-y-1"
                      >
                        <Popover.Panel className="absolute z-10 mt-3 px-2 sm:px-0">
                          {({ close }) => (
                            <div className="overflow-hidden rounded-[5px] shadow-lg ring-1 ring-black ring-opacity-5">
                              <div
                                className="relative grid gap-2 bg-primaryDarkBg text-primaryWhite pl-5 py-6 sm:gap-2 sm:px-4"
                                //  onClick={handleDropdown}
                              >
                                {solutions.map((item) => (
                                  <a
                                    key={item.name}
                                    href={item.href}
                                    className=" w-full flex justify-start rounded-[5px] py-3 px-2 hover:bg-[#EEF0F3] group"
                                    onClick={async () => {
                                      close();
                                    }}
                                  >
                                    <div className="mx-4 ">
                                      <h2
                                        className={`text-[14px] xl:text-[16px] leading-4 xl:leading-6 tracking-[0.07px] font-[500] w-full ${
                                          currentPage === item.href.substring(1)
                                            ? "text-ikarus-blue"
                                            : "text-primaryWhite group-hover:text-[#16181C]"
                                        }`}
                                      >
                                        {item.name}
                                      </h2>
                                    </div>
                                  </a>
                                ))}
                              </div>
                            </div>
                          )}
                        </Popover.Panel>
                      </Transition>
                    </>
                  )}
                </Popover>
                <a
                  href="/why-us"
                  className={`text-[14px] xl:text-[16px] leading-4 xl:leading-6 tracking-[0.07px] font-[500] flex items-center ${
                    currentPage === "why-us"
                      ? "text-ikarus-blue"
                      : "text-primaryWhite"
                  }  relative overflow-y-hidden`}
                >
                  <span className="">Why us</span>
                  <div
                    className={`w-full h-[2px] absolute ${
                      currentPage === "why-us" ? "bottom-0" : "-bottom-1"
                    } transition-all duration-300 ease-linear rounded-t-[3px] bg-primaryBlue`}
                  ></div>
                </a>
                <a
                  href="/portfolio"
                  className={`text-[14px] xl:text-[16px] leading-4 xl:leading-6 tracking-[0.07px] font-[500] flex items-center ${
                    currentPage === "portfolio"
                      ? "text-ikarus-blue"
                      : "text-primaryWhite"
                  }  relative overflow-y-hidden`}
                >
                  <span className="">Portfolio</span>
                  <div
                    className={`w-full h-[2px] absolute ${
                      currentPage === "portfolio" ? "bottom-0" : "-bottom-1"
                    } transition-all duration-300 ease-linear rounded-t-[3px] bg-primaryBlue`}
                  ></div>
                </a>
                <a
                  href="/careers"
                  className={`text-[14px] xl:text-[16px] leading-4 xl:leading-6 tracking-[0.07px] font-[500] flex items-center ${
                    currentPage === "careers"
                      ? "dark:text-ikarus-blue"
                      : "text-primaryWhite"
                  }  relative overflow-y-hidden`}
                >
                  <span className="">Careers</span>
                  <div
                    className={`w-full h-[2px] absolute ${
                      currentPage === "careers" ? "bottom-0" : "-bottom-1"
                    } transition-all duration-300 ease-linear rounded-t-[3px] bg-primaryBlue`}
                  ></div>
                </a>
                <a
                  href={env.BLOG_URL}
                  className={`text-[14px] xl:text-[16px] leading-4 xl:leading-6 tracking-[0.07px] font-[500] flex items-center text-primaryWhite relative overflow-y-hidden
                  ${
                    currentPage === "blog"
                      ? "dark:text-ikarus-blue"
                      : "text-primaryWhite"
                  }`}
                >
                  <span className="">Blog</span>
                  <div
                    className={`w-full h-[2px] absolute ${
                      currentPage === "blog" ? "bottom-0" : "-bottom-1"
                    } transition-all duration-300 ease-linear rounded-t-[3px] bg-primaryBlue`}
                  ></div>
                </a>
                <a
                  href="/media/"
                  className={`text-[14px] xl:text-[16px] leading-4 xl:leading-6 tracking-[0.07px] font-[500] flex items-center ${
                    currentPage === "media"
                      ? "dark:text-ikarus-blue"
                      : "text-primaryWhite"
                  }  relative overflow-y-hidden`}
                >
                  <span className="">Media</span>
                  <div
                    className={`w-full h-[2px] absolute ${
                      currentPage === "media" ? "bottom-0" : "-bottom-1"
                    } transition-all duration-300 ease-linear rounded-t-[3px] bg-primaryBlue`}
                  ></div>
                </a>
              </Popover.Group>

              <div className="hidden items-center justify-start md:flex">
                <PrimaryButton
                  content="Contact us"
                  link="/contact-us"
                />
              </div>
            </div>
          </div>
        </div>

        <Transition
          as={Fragment}
          enter="duration-200 ease-out"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="duration-100 ease-in"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Popover.Panel
            focus
            className="absolute inset-x-0 z-20 top-0 origin-top-right transform pt-2 transition lap:hidden bg-primaryDarkBg text-primaryWhite"
          >
            {({ close: closeOuter }) => (
              <div className="divide-y-2 divide-primaryBlue rounded-[5px] shadow-lg ring-1 ring-black ring-opacity-5">
                <div className="px-[46px] md:px-[112px] flex items-center justify-end">
                  <div className="-mr-2">
                    <Popover.Button className="inline-flex items-center justify-center rounded-[5px]  p-2 text-primaryWhite focus:outline-none focus:ring-2 focus:ring-inset focus:ring-ikarus-blue">
                      <span className="sr-only">Close menu</span>
                      <XMarkIcon
                        className="h-6 w-6"
                        aria-hidden="true"
                      />
                    </Popover.Button>
                  </div>
                </div>

                <div className="space-y-6 py-6 px-10 tab:px-16 lap:px-5">
                  <div className="grid grid-cols-2 gap-y-4 gap-x-8">
                    <a
                      onClick={async () => {
                        closeOuter();
                      }}
                      href="/about-us"
                      className={`text-sm xl:text-2xl ${
                        currentPage === "about-us"
                          ? "dark:text-primaryBlue"
                          : "dark:text-primaryWhite"
                      } hover:text-gray-700`}
                    >
                      About us
                    </a>
                    <a
                      onClick={async () => {
                        closeOuter();
                      }}
                      href="/careers"
                      className={`text-sm xl:text-2xl ${
                        currentPage === "careers"
                          ? "dark:text-primaryBlue"
                          : "dark:text-primaryWhite"
                      } hover:text-gray-700`}
                    >
                      Careers
                    </a>

                    <Popover className="w-full">
                      {({ open }) => (
                        <>
                          <Popover.Button
                            className={`
                ${open ? "w-full" : "text-opacity-90"}
                relative group rounded-[5px] bg-transparent text-sm xl:text-2xl hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 w-full text-start flex`}
                          >
                            <span className="">Services</span>
                            <ChevronDownIcon
                              className={`${open ? "" : "text-opacity-70"}
                          mt-[1px] h-5 w-5 text-primaryWhite transition duration-150 ease-in-out`}
                              aria-hidden="true"
                            />
                          </Popover.Button>
                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-200"
                            enterFrom="opacity-0 translate-y-1"
                            enterTo="opacity-100 translate-y-0"
                            leave="transition ease-in duration-150"
                            leaveFrom="opacity-100 translate-y-0"
                            leaveTo="opacity-0 translate-y-1"
                          >
                            <Popover.Panel className="absolute z-10 mt-3 px-2 lg:right-0">
                              {({ close: closeInner }) => (
                                <div className="overflow-hidden rounded-[5px] shadow-sm ring-1 ring-black ring-opacity-5 w-[250px]">
                                  <div
                                    className="relative grid gap-2 bg-primaryDarkBg text-primaryWhite px-4 py-6 sm:gap-2"
                                    //  onClick={handleDropdown}
                                  >
                                    {solutions.map((item) => (
                                      <a
                                        key={item.name}
                                        href={item.href}
                                        className=" w-full flex justify-start rounded-[5px] py-3 px-1"
                                        onClick={async () => {
                                          closeInner();
                                          closeOuter();
                                        }}
                                      >
                                        <div className="mx-4 ">
                                          <h2
                                            className={`text-sm xl:text-2xl w-full ${
                                              currentPage ===
                                              item.href.substring(1)
                                                ? "dark:text-ikarus-blue"
                                                : "dark:text-primaryWhite"
                                            }`}
                                          >
                                            {item.name}
                                          </h2>
                                        </div>
                                      </a>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </Popover.Panel>
                          </Transition>
                        </>
                      )}
                    </Popover>
                    <a
                      onClick={async () => {
                        closeOuter();
                      }}
                      href={env.BLOG_URL}
                      className={`text-sm xl:text-2xl text-primaryWhite mt-[4px] relative overflow-y-hidden`}
                    >
                      <span className="">Blog</span>
                    </a>
                    <a
                      onClick={async () => {
                        closeOuter();
                      }}
                      href="/why-us"
                      className={`text-sm xl:text-2xl  ${
                        currentPage === "why-us"
                          ? "dark:text-primaryBlue"
                          : "dark:text-primaryWhite"
                      } hover:text-gray-700`}
                    >
                      Why us
                    </a>

                    <a
                      onClick={async () => {
                        closeOuter();
                      }}
                      href="/media/"
                      className={`text-sm xl:text-2xl ${
                        currentPage === "media"
                          ? "dark:text-primaryBlue"
                          : "dark:text-primaryWhite"
                      } hover:text-gray-700`}
                    >
                      Media
                    </a>
                    <a
                      onClick={async () => {
                        closeOuter();
                      }}
                      href="/portfolio"
                      className={`text-sm xl:text-2xl ${
                        currentPage === "portfolio"
                          ? "dark:text-primaryBlue"
                          : "dark:text-primaryWhite"
                      } hover:text-gray-700`}
                    >
                      Portfolio
                    </a>
                  </div>
                  <div className="w-full mt-4">
                    <a
                      href="/contact-us"
                      className="w-full text-center mx-auto flex items-center tab:text-sm px-4 py-2 h-[45px] rounded-[5px] text-white shadow-xs"
                      style={{
                        background:
                          "linear-gradient(to right, #015EF1, #489BE1)",
                      }}
                    >
                      <span className="mx-auto">Contact us</span>
                    </a>
                  </div>
                </div>
              </div>
            )}
          </Popover.Panel>
        </Transition>
      </Popover>
    </motion.div>
  );
}
